export default __webpack_public_path__ + "media/images/social-e8d59f37b08774aae322e3fcc6644c1a.png";